// extracted by mini-css-extract-plugin
module.exports = {"common-recommend":"index-module_common-recommend_2n_5S","common-recommend-icon":"index-module_common-recommend-icon_2jyQ1","good":"index-module_good_1LHOD"};